import { render, staticRenderFns } from "./Dictionary_type.vue?vue&type=template&id=3cb8f6a4&style=height%3A100%25"
import script from "./Dictionary_type.vue?vue&type=script&lang=js"
export * from "./Dictionary_type.vue?vue&type=script&lang=js"
import style0 from "./Dictionary_type.vue?vue&type=style&index=0&id=3cb8f6a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports